import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u6s27vxprc: FaireBrandEntity = {
  token: "b_u6s27vxprc",
  type: "brand",
  name: "Brickcraft",
  avatarUrl:
    "https://cdn.faire.com/fastly/dddb754833a92bee0771f0045928470ca75dd6efa2b560cc66916fb0f577e3d8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f6ea959aa45748ce96c6be30606110eba6c702739e8e1969c6fda0a4e357f546.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dddb754833a92bee0771f0045928470ca75dd6efa2b560cc66916fb0f577e3d8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f6ea959aa45748ce96c6be30606110eba6c702739e8e1969c6fda0a4e357f546.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 138,
  rating: 5,
  reviewCount: 7,
  productCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "We challenge the status quo by designing sets that reflect today’s pop culture, niche fandoms, and iconic moments. With a bold voice and rebellious spirit, we create products that speak directly to fans who want something different. Our builds are unapologetically fun, timely, and rooted in the things people actually care about.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.904Z",
    importedBy: "entity-db-cli",
  },
};
